import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface SubmissionPositionProps {
  readonly drop: ApiDrop;
}
export const SubmissionPosition: React.FC<SubmissionPositionProps> = t0 => {
  const $ = _c(5);
  const {
    drop
  } = t0;
  const rank = drop.rank;
  if (!rank) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function getOrdinalSuffix(n) {
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod10 === 1 && mod100 !== 11) {
        return "st";
      }
      if (mod10 === 2 && mod100 !== 12) {
        return "nd";
      }
      if (mod10 === 3 && mod100 !== 13) {
        return "rd";
      }
      return "th";
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const getOrdinalSuffix = t1;
  let colorClasses;
  let rankText;
  bb0: switch (rank) {
    case 1:
      {
        colorClasses = "tw-bg-yellow-500/10 tw-text-yellow-400 tw-border-yellow-500/20";
        rankText = "1st";
        break bb0;
      }
    case 2:
      {
        colorClasses = "tw-bg-iron-400/10 tw-text-iron-300 tw-border-iron-400/20";
        rankText = "2nd";
        break bb0;
      }
    case 3:
      {
        colorClasses = "tw-bg-amber-600/10 tw-text-amber-500 tw-border-amber-600/20";
        rankText = "3rd";
        break bb0;
      }
    default:
      {
        colorClasses = "tw-bg-iron-600/20 tw-text-iron-400 tw-border-iron-600/20";
        rankText = `${rank}${getOrdinalSuffix(rank)}`;
      }
  }
  const t2 = `tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-semibold tw-border tw-border-solid tw-whitespace-nowrap tw-w-fit ${colorClasses}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faTrophy} className="tw-size-2.5" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== rankText || $[3] !== t2) {
    t4 = <div className={t2}>{t3}{rankText}</div>;
    $[2] = rankText;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};